import { useQuery } from 'react-query'

import { fetchFile } from '@features/attachments/query-api'

import { QueryKeys } from '../../../enums/queryKeys'
import { isApiNotFoundError } from '../../../utils/isApiNotFoundError'

/**
 * A 404 is an answer, not a failure: the query resolves it to `null`, so it is neither retried nor
 * reported and `file` is `undefined`. Callers own the error UI — nothing here toasts.
 *
 * Keyed apart from `useFetchFile`, whose cache entry for the same file id rejects on a 404.
 */
export const useFetchImportedInvoiceFile = (fileId?: string) => {
  const { data: fileResponse, ...rest } = useQuery(
    [QueryKeys.ImportedInvoice, 'file', fileId],
    async () => {
      try {
        return await fetchFile(fileId as string)
      } catch (fetchError) {
        if (isApiNotFoundError(fetchError)) {
          return null
        }

        throw fetchError
      }
    },
    {
      enabled: !!fileId,
    },
  )

  return {
    file: fileResponse?.file,
    ...rest,
  }
}
